export const globalState = {
    isTaskUnfinished: false,
    isPaymentSuccessful: false 
  };
  